import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Aperture } from "lucide-react";
import Reveal from "./Reveal";

export default function ShowcaseBand() {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ["start end", "end start"],
    });
    const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

    return (
        <section className="relative py-10 md:py-16">
            <div className="mx-auto max-w-7xl px-6 md:px-10">
                <Reveal>
                    <div
                        ref={ref}
                        className="relative h-[52vh] overflow-hidden rounded-3xl border border-white/10 md:h-[64vh]"
                    >
                        <motion.img
                            style={{ y }}
                            src="https://images.unsplash.com/photo-1505740420928-5e560c06d30e?crop=entropy&cs=srgb&fm=jpg&q=85"
                            alt="NEXORA One studio series headphones under a spotlight"
                            loading="lazy"
                            className="absolute inset-0 h-full w-full scale-[1.22] object-cover"
                        />
                        {/* spotlight + cinematic grade */}
                        <div
                            aria-hidden="true"
                            className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_0%,rgba(8,10,18,0.55)_70%,rgba(8,10,18,0.9)_100%)]"
                        />
                        <div
                            aria-hidden="true"
                            className="absolute inset-0 bg-gradient-to-t from-ink/90 via-transparent to-ink/40"
                        />
                        <div
                            aria-hidden="true"
                            className="absolute inset-0 bg-[linear-gradient(100deg,rgba(0,240,255,0.08),transparent_40%,rgba(168,85,247,0.1))] mix-blend-screen"
                        />

                        <div className="absolute left-5 top-5 flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.3em] text-white/60 md:left-8 md:top-8">
                            <Aperture className="h-4 w-4 text-volt" />
                            Studio test — 01
                        </div>

                        <div className="glass absolute bottom-5 left-5 right-5 flex items-center justify-between rounded-xl px-5 py-4 md:bottom-8 md:left-8 md:right-auto md:gap-10 md:px-7">
                            <div>
                                <p className="font-display text-sm font-bold uppercase tracking-[0.15em] text-white md:text-base">
                                    Nexora One — Studio Series
                                </p>
                                <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.25em] text-white/45">
                                    Shot on location · zero retouch
                                </p>
                            </div>
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
